module.exports = __webpack_public_path__ + "media/components/NewAsset/icons/insurance-life-5a03263f3594885247ca3688fc10af0c.svg";